import { useState } from 'react';
import clsx from 'clsx';
import FeedList from '../components/cc/FeedList';
import ReportsPanel from '../components/reports/ReportsPanel';

type Tab = 'diary' | 'reports';

export default function WarDiaryPage() {
  const [tab, setTab] = useState<Tab>('diary');

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-lg font-display font-bold text-gray-100">War Diary</h1>
        <p className="text-gray-500 text-[11px]">
          Live event feed &amp; field reports · filter, acknowledge &amp; export for after-action review
        </p>
      </div>

      <div className="flex gap-2">
        {([
          { id: 'diary', label: 'War Diary' },
          { id: 'reports', label: 'Reports' },
        ] as { id: Tab; label: string }[]).map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            className={clsx(
              'px-4 py-2 rounded-lg text-sm font-medium transition-colors touch-manipulation',
              tab === t.id
                ? 'bg-command-accent text-command-bg'
                : 'bg-command-panel border border-command-border text-gray-400 hover:text-white hover:border-gray-500'
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === 'diary' ? <FeedList /> : <ReportsPanel />}
    </div>
  );
}
